var React = require('react');

function ChecksquareInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"196.75","cy":"196.75","r":"196.75","style":{"fill":"#557c99"},"key":0}),React.createElement("path",{"d":"M274.8,293.34H118.7a21.29,21.29,0,0,1-21.29-21.29V116A21.29,21.29,0,0,1,118.7,94.66H274.8A21.29,21.29,0,0,1,296.09,116v156.1A21.29,21.29,0,0,1,274.8,293.34ZM184,249.85l81.6-81.6a7.09,7.09,0,0,0,0-10l-10-10a7.09,7.09,0,0,0-10,0L179,214.73l-31.07-31.07a7.09,7.09,0,0,0-10,0l-10,10a7.09,7.09,0,0,0,0,10L174,249.85a7.1,7.1,0,0,0,10,0Z","style":{"fill":"#fff"},"key":1})]);
}

ChecksquareInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 393.5 393.5"};

module.exports = ChecksquareInline;

ChecksquareInline.default = ChecksquareInline;
